import { render, staticRenderFns } from "./SimpleDataSelectFilter.vue?vue&type=template&id=0d67223e&"
import script from "./SimpleDataSelectFilter.vue?vue&type=script&lang=js&"
export * from "./SimpleDataSelectFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports